import BulkEditSpecDetailsModal from "./BulkEditSpecDetailsModalContainer";

export default BulkEditSpecDetailsModal;
